import type { SVGProps } from 'react';

interface SuccessCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SuccessCircleIcon({ className, ...props }: SuccessCircleIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="8" cy="8" r="8" fill="currentColor" />
      <path
        d="M4.75 8.25L7 10.5L11.25 5.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
